export default "__VITE_ASSET__DmnesBzb__"